/**
 * Define the error components
 */
require('./components');